import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';
import {Venue} from './venues';
import {Observable} from 'rxjs';
import {VenuesService} from './venues.service';

export const VenuesResolverService: ResolveFn<Venue[]> = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<Venue[]> => {
    const venuesService: VenuesService = inject(VenuesService)
    return venuesService.list();
}
